import { useFeedbackFlowStore } from "../stores/feedback-flow-store";

export function useFeedbackFlow() {
	const currentStep = useFeedbackFlowStore((state) => state.currentStep);
	const data = useFeedbackFlowStore((state) => state.data);
	const isDirty = useFeedbackFlowStore((state) => state.isDirty);
	const isComplete = useFeedbackFlowStore((state) => state.isComplete);

	const setRating = useFeedbackFlowStore((state) => state.setRating);
	const setNegativeFeedback = useFeedbackFlowStore((state) => state.setNegativeFeedback);
	const setConsent = useFeedbackFlowStore((state) => state.setConsent);
	const setUserInfo = useFeedbackFlowStore((state) => state.setUserInfo);
	const setCompanyInfo = useFeedbackFlowStore((state) => state.setCompanyInfo);
	const setTestimonialAnswer = useFeedbackFlowStore((state) => state.setTestimonialAnswer);

	const nextStep = useFeedbackFlowStore((state) => state.nextStep);
	const prevStep = useFeedbackFlowStore((state) => state.prevStep);
	const canGoBack = useFeedbackFlowStore((state) => state.canGoBack);
	const canProceed = useFeedbackFlowStore((state) => state.canProceed);
	const reset = useFeedbackFlowStore((state) => state.reset);
	const complete = useFeedbackFlowStore((state) => state.complete);

	return {
		currentStep,
		data,
		isDirty,
		isComplete,
		setRating,
		setNegativeFeedback,
		setConsent,
		setUserInfo,
		setCompanyInfo,
		setTestimonialAnswer,
		nextStep,
		prevStep,
		canGoBack,
		canProceed,
		reset,
		complete,
	};
}
